import { useEffect, useState } from 'react';
import { api } from '@/lib/api';
import { etb } from '@/lib/money';

interface Row {
    rank: number;
    name: string;
    phone_masked: string | null;
    wins: number;
    winnings: number;
}

type Period = 'daily' | 'weekly' | 'monthly';

export function Leaderboard() {
    const [period, setPeriod] = useState<Period>('weekly');
    const [rows, setRows] = useState<Row[] | null>(null);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        let cancelled = false;
        setRows(null);
        api.get<{ data: Row[] }>(`/leaderboard?period=${period}`)
            .then((res) => {
                if (!cancelled) setRows(res.data.data);
            })
            .catch((e) => {
                if (!cancelled) {
                    setError(e instanceof Error ? e.message : 'Could not load leaderboard');
                    setRows([]);
                }
            });
        return () => {
            cancelled = true;
        };
    }, [period]);

    return (
        <div className="lobby leaderboard-page">
            <div className="lobby-connected">✓ Connected</div>
            <div className="lb-hero">
                <div className="lb-trophy">🏆</div>
                <h1>Leaderboard</h1>
                <p>Top players and champions</p>
            </div>

            <div className="profile-tabs">
                {(['daily', 'weekly', 'monthly'] as Period[]).map((p) => (
                    <button key={p} className={period === p ? 'on' : ''} onClick={() => setPeriod(p)}>
                        {p === 'daily' ? 'Daily' : p === 'weekly' ? 'Weekly' : 'Monthly'}
                    </button>
                ))}
            </div>

            {error && <div className="lobby-empty">{error}</div>}
            {rows === null && <div className="lobby-empty">Loading…</div>}
            {rows && rows.length === 0 && <div className="lobby-empty">No winners yet this period.</div>}
            {rows?.map((row) => (
                <div key={`${row.rank}-${row.name}`} className={`lb-card rank-${row.rank}`}>
                    <div className="lb-rank">{row.rank === 1 ? '👑' : row.rank === 2 ? '🏆' : '⭐'}</div>
                    <div className="profile-avatar sm">👤</div>
                    <div className="lb-who">
                        <strong>{row.name}</strong>
                        <span>{row.phone_masked ?? ''}</span>
                    </div>
                    <div className="lb-stats">
                        <span>{row.wins} wins</span>
                        <strong>{etb(row.winnings)} ETB</strong>
                    </div>
                </div>
            ))}
        </div>
    );
}
